import { BaseControl } from '.';
import DraggableNumberInput from '../components/DraggableNumberInput';

/**
 * @typedef {object} NumberControlOptions
 * @property {number} [min] - Minimum value
 * @property {number} [max] - Maximum value
 * @property {number} [step] - Step increment
 */

/**
 * @extends {BaseControl<number, NumberControlOptions>}
 */
export class NumberControl extends BaseControl {

    /** @type {BaseControl<number>['render']} */
    render(value, onChange) {
        return (
            <label className="number-control">
                {this.label}
                {/* <input 
                    type="number" 
                    value={value} 
                    name={this.label}
                    onChange={(e) => onChange(Number(e.target.value))}
                    placeholder={this.description}
                    min={this.options?.min}
                    max={this.options?.max}
                    step={this.options?.step}
                /> */}
                <DraggableNumberInput
                    value={value}
                    onChange={(num) => onChange(num)}
                    min={this.options?.min}
                    max={this.options?.max}
                    step={this.options?.step}
                />
            </label>
        );
    }
}
